import { render, staticRenderFns } from "./NewHubCategoryModal.vue?vue&type=template&id=e4875c78&"
import script from "./NewHubCategoryModal.vue?vue&type=script&lang=js&"
export * from "./NewHubCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports